import react from "react"
import Aos from "aos"
import logo from "./images/CSI-Logo.png"
import "aos/dist/aos.css"
import "./overview.css"

const Teams = () => {
  react.useEffect(() => {
    Aos.init({ duration: 1200 })
  }, [])
  return (
    <header className="hero2" data-aos="fade-up">
      <div className="parent">
        <div>
          <div className="card2">
            <h4>Achievemnets</h4>
            Achievemnets of the club over the years in various events
            <a href="/achievements">Know More</a>
          </div>
          <div className="card2">
            <h4>Events</h4>
            Various events organised by the Club throughout the year
            <a href="/events">Know More</a>
          </div>

          <div className="card2">
            <h4>Technex</h4>
            The club participates in the annual Technological festival of IIT
            BHU
            <a
              href="https://www.technex.co.in/events#:~:text=Riqueza-,Pahal,-Extreme%20Engineering"
              target="_blank"
              rel="noreferrer"
            >
              Know More
            </a>
          </div>
        </div>

        <div className="hero">
          <img src={logo} alt="Logo" />
          <div className="heroLogoTxt">
            <span id="heroLogoTxt1">CLUB OF</span>
            <span id="heroLogoTxt2">SUSTAINABILITY</span>
            <span id="heroLogoTxt3"> & </span>
            <span id="heroLogoTxt4">INNOVATION</span>
          </div>
        </div>

        <div>
          <div className="card2">
            <h4>Projects</h4>
            CSI's Innovative projects have solved 30+ life-changing problems
            across the fields
            <a href="/projects">Know More</a>
          </div>
          <div className="card2">
            <h4>Team</h4>
            Various vertical in the Club
            <a href="/team">Know More</a>
          </div>
          <div className="card2">
            <h4>Workshops</h4>
            Various workshops are organised over the year to give a insight into
            various technologies.
            <a href="/workshops">Know More</a>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Teams
